export default __webpack_public_path__ + "static/media/feedback.cd7b7bb1.svg";